export default "__VITE_ASSET__DIwVSf2x__"